module.exports = __webpack_public_path__ + "img/buenos_aires_flores.caea3fb5.jpg";